module.exports = __webpack_public_path__ + "media/images/dashboard/wedding_styles/luxury1-fc34ef9c64547cf7743d98a59c9b3888.jpg";